import {useControlledState as $ihOoW$useControlledState} from "@react-stately/utils";


function $0b2218c4e3fe7d7e$export$3f8be18b0f41eaf2(props) {
    let [value, setValue] = $ihOoW$useControlledState($0b2218c4e3fe7d7e$var$toString(props.value), $0b2218c4e3fe7d7e$var$toString(props.defaultValue) || '', props.onChange);
    return {
        value: value,
        setValue: setValue
    };
}
function $0b2218c4e3fe7d7e$var$toString(val) {
    if (val == null) return;
    return val.toString();
}




export {$0b2218c4e3fe7d7e$export$3f8be18b0f41eaf2 as useSearchFieldState};
//# sourceMappingURL=module.js.map
